import script from "./FechamentoPeriodosCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./FechamentoPeriodosCadastro.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__